import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { personalizeAction } from '../../store/pesonalize-store';
let uniqueArr=[];

const ListElements = ({toEmails}) => {
    const [emails, setEmails] = useState([]);
    const dispatch = useDispatch();

    useEffect(()=>{
        uniqueArr = [...new Set(toEmails.map(item => item.email))];
        setEmails(uniqueArr.filter(item => item))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[toEmails])

    const removeTags = index => {
        const indexObj = toEmails.findIndex( (element) => element.email === emails[index]);
        setEmails([...emails.filter(tag => emails.indexOf(tag) !== index)]);
        // setAddEmails([...selectedEmails.filter(tag => selectedEmails.indexOf(tag) !== index)]);
        dispatch(
            personalizeAction.setEmailContacts({
                personalize_emailContacts: [...toEmails.filter((tag,index) => index !== indexObj)],
            })
        );
    };



  return (
    <div className="tags-input p-0 p-0 border-0 w-100 align-items-center">
        <ul id="tags h-100">
            {emails.map((tag, index) => (
                
                <li key={index} className="tag d-inline-flex mb-0 mt-2">
                    <span className="tag-tile">{tag}</span>
                    <i 
                        className="tag-close-icon"
                        onClick={() => removeTags(index)}
                        style={{display: "inline-block"}}
                    >x</i>
                </li>
            ))}
        </ul>
    </div>
  )
}

export default ListElements